import React from 'react';
import { Inbox } from '@bynder/notifications-frontend';

export function HybridNotificationCenter() {
	return (
		<li className="notifications-nav">
			<Inbox />
		</li>
	);
}
